<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="center">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-form-item label="父级业态" prop="parent_id" required>
          <el-select v-model="form.parent_id" filterable clearable placeholder="一级">
            <el-option v-for="i of goodsCategoriesOptions" :key="i.id" :label="i.title" :value="i.id">
              <span>{{ i.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="编码" required prop="code">
          <el-input v-model="form.code" />
        </el-form-item>

        <el-form-item label="名称" required prop="title">
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item label="图标" prop="pic">
          <file-picker v-model="form.pic" info="必选，选1张图，一张选中icon，一张未选中icon；只能上传jpg、jpeg、png文件，36*36px" />
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="-9999" :max="9999" />
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" />
        </el-form-item>

        <el-form-item label="是否可用" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { createGoodsCategory, editGoodsCategory, storeGoodsCategory, updateGoodsCategory } from '@/api/goods-categories'
import icons from '@/icons'
import { nestedToSelectOptions, toInt } from '@/libs/utils'
import FilePicker from '@c/FilePicker'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import pages from '@v/pages'

export default {
  name: 'GoodsForm',
  components: {
    LzForm,
    FilePicker,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        id: 0,
        parent_id: 0,
        title: '',
        code: '',
        value: '',
        sort: '',
        remark: '',
        status: 0,
      },
      errors: {},

      goodsCategories: [],
    }
  },
  computed: {
    goodsCategoriesOptions() {
      return nestedToSelectOptions(this.goodsCategories)
    },
    icons() {
      return icons
    },
  },
  created() {
    this.initPaths()
  },
  methods: {
    queryParentId() {
      const id = toInt(this.$route.query.parent_id)
      if (this.goodsCategoriesOptions.some(i => i.id === id)) {
        return id
      } else {
        return 0
      }
    },
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editGoodsCategory(this.resourceId))
        this.fillForm(data.goods_category)
      } else {
        ;({ data } = await createGoodsCategory())
      }

      this.goodsCategories = data.goods_categories
      !this.editMode && (this.form.parent_id = this.queryParentId())
    },
    async onSubmit() {
      if (this.editMode) {
        this.form.id = this.resourceId
        await updateGoodsCategory(this.resourceId, this.form)
      } else {
        this.form.id = 0
        await storeGoodsCategory(this.form)
      }
    },
    initPaths() {
      this.paths = Object.keys(pages)
        .sort()
        .map(i => ({ value: i }))
    },
    pathSearch(q, cb) {
      const results = q ? this.paths.filter(i => i.value.indexOf(q) !== -1) : this.paths
      cb(results)
    },
  },
}
</script>

<style scoped lang="scss"></style>
